module.exports = __webpack_public_path__ + "img/PGR_A05_front_horizontal_en.164a36b7.png";